import { render, staticRenderFns } from "./NotSafeForWork3.vue?vue&type=template&id=3e90d490&scoped=true&"
import script from "./NotSafeForWork3.vue?vue&type=script&lang=js&"
export * from "./NotSafeForWork3.vue?vue&type=script&lang=js&"
import style0 from "./NotSafeForWork3.vue?vue&type=style&index=0&id=3e90d490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90d490",
  null
  
)

export default component.exports